import React from 'react';
import { Row, Col } from 'react-bootstrap'

export default function Company(){
    
    return(
        <>
            <Col>
                <Row>
                    <Col>
                        
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} className="pr-lg-5">
                        <h1 className="pt-0">Liebe Gartenfreunde,</h1>
                        <p className="pr-lg-5">
                            oder die, die es werden wollen.
                        </p>
                        <p className="pr-lg-5">
                            So läufts bei uns: Sie schreiben uns eine Mail oder greifen zum Hörer. Dann kommen wir vorbei
                            und beraten Sie bei Ihrem Projekt, Umbau, Neubau oder anstehenden Pflegearbeiten. Nun werden Skizzen angefertigt, passende 
                            Materialien für Ihren Garten herausgesucht sowie ein kostenloses Angebot erstellt. Wenn wir uns hier einig sind, dann folgt
                            Schritt 2 - die Gartenbauerei.
                        </p>
                        <p className="pr-lg-5">
                            Dann rückt das Henkel-Team an, baggert, pflastert, baut Terrassen und Zäune, pflanzt und fällt auch Ihre Bäume. ....
                            und natürlich noch vieles mehr. Wir arbeiten individuell mit Kopf, Herz und Hand.
                        </p>
                        </Col>
                    <Col lg={4} className="ml-lg-4 py-2 py-lg-0">
                        <img src={require('../media/max_1_quad.jpg')} className="img-fluid" />
                    </Col>
                </Row>
                <Row>
                    <Col lg={1}>
                    </Col>
                    <Col lg={5} className="py-2 py-lg-0">
                        <img src={require('../media/wolfi_rund.jpg')} className="img-fluid w-100" />
                    </Col>
                    <Col lg={2}>
                    </Col>
                    <Col lg={4} className="pl-lg-5 pt-lg-5 py-2 py-lg-0">
                        <img src={require('../media/mitarbeiter_rund.jpg')} className="img-fluid w-100" />
                    </Col>
                </Row>
            </Col>
        </>
    )
}